export const DEV_LOGIN_PASSWORD = "dev-team@fixmycity.de"

export const DEV_LOGIN_USERS = [
  ["admin", "admin@fixmycity.test"],
  ["all-projects-viewer", "all-projects-viewer@fixmycity.test"],
  ["all-projects-editor", "all-projects-editor@fixmycity.test"],
  ["no-project", "no-project@fixmycity.test"],
  ["rs23", "rs23@fixmycity.test"],
  ["rs3000", "rs3000@fixmycity.test"],
] as const
